import { Callout } from '@radix-ui/themes'
import { Info } from 'lucide-react'
import type { SetupOrigin } from '@/types/shared'

/** Where a setup form posts: its path, carrying the event they came from. */
export function setupPath(path: string, { event_id }: SetupOrigin) {
  return event_id ? `${path}?event_id=${event_id}` : path
}

/**
 * Over a setup form someone reached from an event's "you need X first": it's
 * a detour, and they'll be back. Nothing when they came from anywhere else.
 */
export default function SetupForEventCallout({ event_name }: SetupOrigin) {
  if (!event_name) return null

  return (
    <Callout.Root color="gray" variant="soft">
      <Callout.Icon>
        <Info size={18} />
      </Callout.Icon>
      <Callout.Text>
        Set this up once — it takes a couple of minutes, and you'll come straight back to finish applying to{' '}
        {event_name}.
      </Callout.Text>
    </Callout.Root>
  )
}
